interface FormFieldReportSectionProps {
  children: React.ReactNode;
}

export const FormFieldReportSection = ({
  children,
}: FormFieldReportSectionProps) => {
  return (
    <div className="bg-slate-100/65 rounded-lg px-6 py-5 flex flex-col gap-1.5">
      {children}
    </div>
  );
};
